import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgRefreshCcw = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M0.833313 3.33331V8.33332M0.833313 8.33332H5.83331M0.833313 8.33332L4.69998 4.69998C5.5956 3.80391 6.70362 3.14932 7.92065 2.79729C9.13768 2.44527 10.4241 2.40727 11.6597 2.68686C12.8954 2.96645 14.0401 3.55451 14.9871 4.39616C15.934 5.23782 16.6523 6.30564 17.075 7.49998M19.1666 16.6666V11.6666M19.1666 11.6666H14.1666M19.1666 11.6666L15.3 15.3C14.4044 16.1961 13.2963 16.8506 12.0793 17.2027C10.8623 17.5547 9.5759 17.5927 8.34022 17.3131C7.10453 17.0335 5.95981 16.4455 5.01287 15.6038C4.06592 14.7621 3.34762 13.6943 2.92498 12.5",
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgRefreshCcw;
